import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const routeCollectorLocalitiesService = {};

routeCollectorLocalitiesService.getRouteCollectorLocalities = params => {
  return fetchV2({
    url: `${env.API_MSP}/collector/route-localities`,
    method: "get",
    params: {
      ...params,
      "filter[record_status]": "O",
    },
  });
};

// clearAllRoute
routeCollectorLocalitiesService.clearAllRouteCollector = () => {
  return fetchV2({
    url: `${env.API_MSP}/collector/route-localities/clear-data`,
    method: "delete",
  });
};
// clearRouteOfHub
routeCollectorLocalitiesService.clearRouteCollectorOfHub = ({ hub_id }) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/route-localities/clear-data/${hub_id}`,
    method: "delete",
  });
};

export default routeCollectorLocalitiesService;
